/**
 * Calculates the number of visible dots in the carousel for a given slide.
 *
 * The number of visible dots grows from `minVisible` at the start, reaches `maxVisible`
 * in the middle, and shrinks back to `minVisible` as the carousel approaches the end.
 *
 * @param selectedIndex - The current slide index
 * @param totalSlides - Total number of slides in the carousel
 * @param minVisible - Minimum number of visible dots
 * @param maxVisible - Maximum number of visible dots
 * @returns The number of visible dots to display
 */
export const getVisibleDots = (
    selectedIndex: number,
    totalSlides: number,
    minVisible: number,
    maxVisible: number
): number => {
    if (selectedIndex < maxVisible - minVisible) {
        // Growing phase at the start
        return minVisible + selectedIndex;
    }
    if (selectedIndex >= totalSlides - (maxVisible - minVisible) - 1) {
        // Shrinking phase at the end
        return Math.max(minVisible, minVisible + (totalSlides - selectedIndex - 1));
    }
    // Middle: constant maxVisible
    return maxVisible;
};
